import { render, staticRenderFns } from "./uploaddown.vue?vue&type=template&id=3908840a"
import script from "./uploaddown.vue?vue&type=script&lang=js"
export * from "./uploaddown.vue?vue&type=script&lang=js"
import style0 from "./uploaddown.vue?vue&type=style&index=0&id=3908840a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports